import Cookies from 'js-cookie';
import Overlay from '../../../javascripts/utils/overlay';

class SocialEmbed {
  constructor($el) {
    this.$el = $el;
    this.$template = $el.querySelector('.social-wall__template');
    this.consentCookieName = $el.getAttribute('data-cookie');

    this.Overlay = new Overlay({
      onConsent: this.onConsent,
      onGlobalConsent: this.onGlobalConsent,
      consentCookieName: this.consentCookieName,
      $el: this.$el,
    });

    this.checkForCookie();
  }

  checkForCookie = () => {
    const neededCookie = Cookies.get(this.consentCookieName) || null;

    if (!neededCookie || neededCookie !== 'accept') {
      this.Overlay.init();
      // Init overlay only if not active yet
      if (!this.$el.classList.contains('social-embed__cookie-overlay-active')) {
        this.$el.classList.add('social-embed__cookie-overlay-active');
      }
    } else {
      this.Overlay.destroy();
      this.initTemplate();
    }
  }

  onConsent = () => {
    this.initTemplate();
  }

  onGlobalConsent = () => {
    this.initTemplate();
    // eslint-disable-next-line
    initSocialWall();
  }

  initTemplate = () => {
    const $parent = this.$el;

    this.$el.classList.remove('social-embed__cookie-overlay-active');
    this.$el.classList.add('social-embed__cookie-consent');

    if (this.$template) {
      const templateHtml = this.$template.innerHTML;

      this.$template.insertAdjacentHTML('afterend', templateHtml);
    }
    if ($parent.querySelector('iframe')) {
      $parent.querySelector('iframe').contentWindow.focus();
    }
  }
}

export default function initSocialWall() {
  document.querySelectorAll('.js-social-wall').forEach($el => new SocialEmbed($el));
}

initSocialWall();
